"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teleMedicinePayloadToFormDataHandler = teleMedicinePayloadToFormDataHandler;
function teleMedicinePayloadToFormDataHandler(data) {
    return {
        visitDate: data.form.visitDate,
        clinicianAppointment: {
            visitDate: data.form.nextVisitDate,
            visitStartTime: data.form.nextVisitStartTime,
            visitEndTime: data.form.nextVisitEndTime,
        },
        nextVisitType: data.form.nextVisitType || "N/A",
        notes: data.form.notes || "",
    };
}
